"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var docDefinitions;
        (function (docDefinitions) {
            var edit;
            (function (edit) {
                function init() {
                    addEvents();
                    appn.folderFilter.initLinkedFolders();
                    if ($('nav .navbar-nav-right button[value*="Trash"]').length > 0)
                        appn.trash.addTrashMessage($('nav .navbar-nav-right button[value*="Trash"]'), '#DocDefinition_Name', 'DocDefinition_VersionNo', 'DocDefinition_Status');
                }
                edit.init = init;
                function addEvents() {
                    $('#saveLink').on('click', function () {
                        $('form#appnForm').submit();
                    });
                }
            })(edit = docDefinitions.edit || (docDefinitions.edit = {}));
        })(docDefinitions = views.docDefinitions || (views.docDefinitions = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
